import axios from "./axiosConfig";

const fetcher = (url: string, options?: any) => axios.get(url, options).then((res) => res.data);
export const poster = (url: string, data: any, options?: any) => axios.post(url, data, options).then((res) => res.data);
export const deleter = (url: string, options?: any) => axios.delete(url, options).then((res) => res.data);

export function fetcherWithKey(key: string) {
  return function (url: string) {
    return axios.get(url).then((res) => res.data[key]);
  };
}

export default fetcher;
